(function (root, factory) {
  var api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    var start = function () { api.initWorldwidePhone(document); };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  }
})(this, function () {
  'use strict';

  function normalizePhone(value) {
    var raw = String(value || '').trim();
    if (!raw) return '';

    var digits = raw.replace(/\D/g, '');

    // Keep the familiar 10-digit Indian flow working for local homeowners.
    if (raw.charAt(0) !== '+' && /^[6-9]\d{9}$/.test(digits)) {
      return '+91' + digits;
    }

    // International numbers must include their country code and fit E.164 length.
    if (raw.charAt(0) !== '+') return '';

    var normalized = '+' + digits;
    return /^\+[1-9]\d{6,14}$/.test(normalized) ? normalized : '';
  }

  function setFieldError(element, hasError) {
    if (!element) return;
    var group = element.closest('.rw-field-group');
    if (group) group.classList.toggle('rw-field--error', hasError);
  }

  function validEmail(value) {
    var email = String(value || '').trim();
    return email === '' || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function initWorldwidePhone(doc) {
    var form = doc.getElementById('RightWorkInquiryForm');
    if (!form || form.getAttribute('data-rw-worldwide-phone') === 'ready') return;

    var phoneInput = form.querySelector('input[name="contact[phone]"]');
    if (!phoneInput) return;

    form.setAttribute('data-rw-worldwide-phone', 'ready');

    var phoneGroup = phoneInput.closest('.rw-field-group');
    var phonePrefix = phoneGroup && phoneGroup.querySelector('.rw-phone-prefix');
    var phoneLabel = phoneGroup && phoneGroup.querySelector('label');
    var phoneError = phoneGroup && phoneGroup.querySelector('.rw-error-message');

    var hiddenSummary = form.querySelector('input[name="contact[body]"]');
    var hiddenService = form.querySelector('input[name="contact[Service Required]"]');
    var hiddenBudget = form.querySelector('input[name="contact[Budget Range]"]');
    var hiddenFiles = form.querySelector('input[name="contact[Floor Plan Files]"]');
    var nameInput = form.querySelector('input[name="contact[name]"]');
    var locationInput = form.querySelector('input[name="contact[Project Location]"]');
    var emailInput = form.querySelector('input[name="contact[email]"]');
    var propertyInput = form.querySelector('select[name="contact[Property Type]"]');
    var messageInput = form.querySelector('textarea[name="contact[Additional Message]"]');
    var consentInput = form.querySelector('.rw-consent input[type="checkbox"]');
    var submitButton = form.querySelector('.rw-submit-btn');
    var whatsappButton = form.querySelector('.rw-whatsapp-btn');

    if (phonePrefix) {
      phonePrefix.textContent = '🌐';
      phonePrefix.setAttribute('title', 'Worldwide phone number');
      phonePrefix.setAttribute('aria-label', 'Worldwide phone number');
    }

    if (phoneLabel) {
      for (var i = 0; i < phoneLabel.childNodes.length; i += 1) {
        if (phoneLabel.childNodes[i].nodeType === 3) {
          phoneLabel.childNodes[i].nodeValue = 'Mobile / WhatsApp Number ';
          break;
        }
      }
    }

    phoneInput.removeAttribute('pattern');
    phoneInput.removeAttribute('maxlength');
    phoneInput.setAttribute('inputmode', 'tel');
    phoneInput.setAttribute('autocomplete', 'tel');
    phoneInput.setAttribute('placeholder', 'e.g. +971 50 123 4567');

    if (phoneError) {
      phoneError.textContent = 'Enter a valid number with country code, for example +971, +1 or +61.';
    }

    function showPhoneState() {
      var ok = normalizePhone(phoneInput.value) !== '';
      setFieldError(phoneInput, !ok);
      return ok;
    }

    function buildSummary(phone) {
      var lines = ['NEW INTERIOR INQUIRY', ''];
      lines.push('Name: ' + ((nameInput && nameInput.value) || ''));
      lines.push('Phone: ' + (phone || ((phoneInput && phoneInput.value) || '')));
      if (locationInput && locationInput.value) lines.push('Location: ' + locationInput.value);
      if (hiddenService && hiddenService.value) lines.push('Service: ' + hiddenService.value);
      if (propertyInput && propertyInput.value) lines.push('Property Type: ' + propertyInput.value);
      if (hiddenBudget && hiddenBudget.value) lines.push('Budget: ' + hiddenBudget.value);
      if (emailInput && emailInput.value) lines.push('Email: ' + emailInput.value);
      if (messageInput && messageInput.value) lines.push('Message: ' + messageInput.value);
      if (hiddenFiles && hiddenFiles.value && hiddenFiles.value !== 'No files uploaded') {
        lines.push('Floor Plan: ' + hiddenFiles.value);
      }
      return lines.join('\n');
    }

    phoneInput.addEventListener('blur', function () {
      showPhoneState();
    });

    phoneInput.addEventListener('input', function () {
      if (phoneGroup && phoneGroup.classList.contains('rw-field--error')) {
        showPhoneState();
      }
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();

      var normalizedPhone = normalizePhone(phoneInput.value);
      var serviceOk = !hiddenService || String(hiddenService.value || '').trim() !== '';
      var nameOk = !nameInput || String(nameInput.value || '').trim().length >= 2;
      var phoneOk = normalizedPhone !== '';
      var emailOk = !emailInput || validEmail(emailInput.value);
      var locationOk = !locationInput || String(locationInput.value || '').trim().length >= 2;
      var consentOk = !consentInput || consentInput.checked;

      setFieldError(hiddenService, !serviceOk);
      setFieldError(nameInput, !nameOk);
      setFieldError(phoneInput, !phoneOk);
      setFieldError(emailInput, !emailOk);
      setFieldError(locationInput, !locationOk);

      if (!consentOk && consentInput && typeof consentInput.reportValidity === 'function') {
        consentInput.reportValidity();
      }

      if (!serviceOk || !nameOk || !phoneOk || !emailOk || !locationOk || !consentOk) {
        var firstError = form.querySelector('.rw-field--error input, .rw-field--error select, .rw-field--error textarea, .rw-field--error button');
        if (firstError) {
          firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
          if (typeof firstError.focus === 'function') firstError.focus();
        }
        return;
      }

      phoneInput.value = normalizedPhone;
      var summary = buildSummary(normalizedPhone);
      if (hiddenSummary) hiddenSummary.value = summary;

      try {
        window.sessionStorage.setItem('rwWorldwideInquirySummary', summary);
      } catch (e) {}

      if (submitButton) {
        submitButton.disabled = true;
        var submitText = submitButton.querySelector('span');
        if (submitText) submitText.textContent = 'Submitting…';
      }

      HTMLFormElement.prototype.submit.call(form);
    }, true);

    if (whatsappButton) {
      whatsappButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();

        var number = whatsappButton.getAttribute('data-wa-number');
        if (!number) return;

        var normalizedPhone = normalizePhone(phoneInput.value);
        var summary = buildSummary(normalizedPhone || phoneInput.value);
        window.open('https://wa.me/' + number + '?text=' + encodeURIComponent(summary), '_blank');
      }, true);
    }
  }

  return {
    normalizePhone: normalizePhone,
    initWorldwidePhone: initWorldwidePhone
  };
});

(function () {
  'use strict';

  function updateNriHomeCta(doc) {
    var link = doc.querySelector('.deepak-v8-root .nri .btn.light[href="/pages/design-consultation"]');
    if (!link) return;
    link.setAttribute('href', '/pages/nri-home-interior-design');
    link.textContent = 'Explore NRI Home Interiors →';
  }

  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { updateNriHomeCta(document); }, { once: true });
    } else {
      updateNriHomeCta(document);
    }
  }
})();
